import { render } from "./customer-report.vue?vue&type=template&id=fd2d182e&scoped=true"
import script from "./customer-report.vue?vue&type=script&lang=js"
export * from "./customer-report.vue?vue&type=script&lang=js"

import "./customer-report.vue?vue&type=style&index=0&id=fd2d182e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2d182e"]])

export default __exports__